/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolHvacIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-hvac"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 18.65Q12 18.65 13.39 18.65Q14.78 18.65 16.71 16.71Q18.65 14.78 18.65 12Q18.65 9.22 16.71 7.29Q14.78 5.35 12 5.35Q9.22 5.35 7.29 7.29Q5.35 9.22 5.35 12Q5.35 14.78 7.29 16.71Q9.22 18.65 12 18.65ZM12 16Q12 16 11.64 16Q11.28 16 10.6 15.74Q9.93 15.47 9.38 15L14.63 15Q14.07 15.47 13.4 15.74Q12.72 16 12 16ZM8.55 14Q8.35 13.65 8.22 13.28Q8.1 12.9 8.05 12.5L15.95 12.5Q15.9 12.9 15.78 13.28Q15.65 13.65 15.45 14ZM8.05 11.5Q8.1 11.1 8.22 10.72Q8.35 10.35 8.55 10L15.45 10Q15.65 10.35 15.78 10.72Q15.9 11.1 15.95 11.5ZM9.38 9Q9.93 8.53 10.6 8.26Q11.28 8 12 8Q12.72 8 13.4 8.26Q14.07 8.53 14.63 9ZM5 21.65Q3.88 21.65 3.11 20.89Q2.35 20.13 2.35 19L2.35 5Q2.35 3.88 3.11 3.11Q3.88 2.35 5 2.35L19 2.35Q20.13 2.35 20.89 3.11Q21.65 3.88 21.65 5L21.65 19Q21.65 20.13 20.89 20.89Q20.13 21.65 19 21.65Z" fill={color} />
    </svg>
  );
}
